var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewFeatureToucan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1077.205,
    height: 1079.126,
    viewBox: "0 0 1077.205 1079.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "535.728 585.172 384.81 959.966 347.745 946.127 497.211 576.623 535.728 585.172",
    fill: "#e9c050",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 588.134,
    y: 589.309,
    width: 42.893,
    height: 353.71,
    fill: "#e9c050",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M161.407,1030.612v19.215a25.568,25.568,0,0,0,25.569,25.569H442.421a22.3,22.3,0,0,0,22.3-22.3v-22.481Z",
    fill: "#fff",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.967,905.638c-35.54,53.1-35.924,124.981-35.924,124.981H161.4s-4.35-85.827,82.788-117.3C260.887,907.269,274.451,905.19,285.967,905.638Z",
    fill: "#fff",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.721,901.223v129.4H250.043s.384-71.879,35.924-124.981c23.68.907,38.673,12.5,54.544,22.3,16.149,9.967,35.277,14.488,54.053,11.73,35.9-5.273,40.254-30.822,45.11-42.7C445.528,882.574,464.721,880.974,464.721,901.223Z",
    fill: "#696969",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.936,920.033c-11.8-7.294-24.567-13.755-41.969-14.395a134.093,134.093,0,0,1,22.8-26.346,7.689,7.689,0,0,1,7.134-1.613c3.8,1.057,9.442,3.874,14.783,11.293C339.868,901.767,331.839,913.891,327.936,920.033Z",
    fill: "#696969",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M839.046,1030.612v19.215a25.569,25.569,0,0,1-25.569,25.569H558.031a22.3,22.3,0,0,1-22.3-22.3v-22.481Z",
    fill: "#fff",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.486,905.638c35.54,53.1,35.923,124.981,35.923,124.981h88.642s4.351-85.827-82.788-117.3C739.565,907.269,726,905.19,714.486,905.638Z",
    fill: "#fff",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.731,901.223v129.4H750.409s-.383-71.879-35.923-124.981c-23.681.907-38.674,12.5-54.545,22.3-16.149,9.967-35.277,14.488-54.052,11.73-35.9-5.273-40.255-30.822-45.111-42.7C554.925,882.574,535.731,880.974,535.731,901.223Z",
    fill: "#696969",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.516,920.033c11.8-7.294,24.568-13.755,41.97-14.395a134.159,134.159,0,0,0-22.8-26.346,7.69,7.69,0,0,0-7.134-1.613c-3.8,1.057-9.442,3.874-14.784,11.293C660.584,901.767,668.613,913.891,672.516,920.033Z",
    fill: "#696969",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.831,473.063H79.343c0-67.386,32.731-119.478,94.655-150.644,44.492-22.393,88.656-25.71,90.513-25.839l3.446,48.363C262.235,345.373,127.831,356.778,127.831,473.063Z",
    fill: "#e9c050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.537,3.73h0a0,0,0,0,1,0,0V259.221a0,0,0,0,1,0,0H258.046a0,0,0,0,1,0,0v0A255.491,255.491,0,0,1,513.537,3.73Z",
    fill: "#86ba98",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.133,259.221h0a0,0,0,0,1,0,0V589.309a0,0,0,0,1,0,0H258.046a0,0,0,0,1,0,0v0A330.087,330.087,0,0,1,588.133,259.221Z",
    transform: "translate(-1.175 847.355) rotate(-90)",
    fill: "#e14a5a",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M918.221,259.221h0a0,0,0,0,1,0,0V589.309a0,0,0,0,1,0,0H588.134a0,0,0,0,1,0,0v0A330.087,330.087,0,0,1,918.221,259.221Z",
    transform: "translate(1177.443 -328.912) rotate(90)",
    fill: "#aed4d9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.951,593.039H584.4V255.492h3.73c184.068,0,333.817,149.749,333.817,333.817ZM591.864,585.58H914.47c-1.985-177.011-145.6-320.622-322.606-322.607Z",
    fill: "#1a1a18"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M918.221,589.309h0a0,0,0,0,1,0,0V919.4a0,0,0,0,1,0,0H588.134a0,0,0,0,1,0,0v0A330.087,330.087,0,0,1,918.221,589.309Z",
    transform: "translate(-1.175 1507.531) rotate(-90)",
    fill: "#deebe8",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.538,3.73h559.937a0,0,0,0,1,0,0V259.221a0,0,0,0,1,0,0H769.029A255.491,255.491,0,0,1,513.538,3.73v0A0,0,0,0,1,513.538,3.73Z",
    transform: "translate(1587.012 262.951) rotate(-180)",
    fill: "#e9c050",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513.538,
    cy: 128.471,
    r: 61.335,
    fill: "#fff",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 499.357,
    cy: 142.652,
    r: 44.758,
    fill: "#1a1a18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.014,752.09v39.946a328.723,328.723,0,0,1-42.893-72.544V589.322A328.468,328.468,0,0,0,631.014,752.09Z",
    fill: "#1a1a18",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40.916,
    y: 453.837,
    width: 130.138,
    height: 227.036,
    rx: 11.949,
    transform: "translate(-82.45 21.812) rotate(-8.474)",
    fill: "#deebe8",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.123,519.876S12.511,503.4,5.186,513.291s14.47,28.289,32.281,35.738Z",
    fill: "#fff",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.742,557.59c5.612,2.667,22.113,15,19.42,24.806-3.025,12.509-27.523.985-32.978-2.581s-7.1-12.629-2.755-18.491S33.131,554.923,38.742,557.59Z",
    fill: "#fff",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.784,588.837c6.136.979,25.442,8.16,25.621,18.332.621,12.854-26.131,8.7-32.37,6.812s-10.371-10.118-7.852-16.966S26.649,587.859,32.784,588.837Z",
    fill: "#fff",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.482,621.765c6.156-.845,26.715.421,29.84,10.1,4.326,12.119-22.48,15.909-29,15.916s-12.861-6.67-12.439-13.955S27.327,622.61,33.482,621.765Z",
    fill: "#fff",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.9,534.634s1.745-20.446,14.3-21.032c17.073-.8,1.643,33.922,7.971,54.819,4.482,14.8,7.335,22.909,5.16,33.965-3.485,17.708-13.846,23.44-13.846,23.44Z",
    fill: "#fff",
    stroke: "#1a1a18",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  })), /*#__PURE__*/React.createElement("rect", {
    x: 116.514,
    y: 465.729,
    width: 25.258,
    height: 25.258,
    rx: 4.963,
    transform: "translate(-69.082 24.253) rotate(-8.474)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.887,
    y: 471.037,
    width: 25.258,
    height: 25.258,
    rx: 4.963,
    transform: "translate(-70.254 19.061) rotate(-8.474)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.26,
    y: 476.345,
    width: 25.258,
    height: 25.258,
    rx: 4.963,
    transform: "translate(-71.425 13.869) rotate(-8.474)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.452,
    y: 633.108,
    width: 25.258,
    height: 25.258,
    rx: 4.963,
    transform: "translate(-93.476 29.756) rotate(-8.474)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.825,
    y: 638.416,
    width: 25.258,
    height: 25.258,
    rx: 4.963,
    transform: "translate(-94.647 24.563) rotate(-8.474)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.197,
    y: 643.724,
    width: 25.258,
    height: 25.258,
    rx: 4.963,
    transform: "translate(-95.818 19.371) rotate(-8.474)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.195,
    y: 506.664,
    width: 25.258,
    height: 25.258,
    rx: 4.963,
    transform: "translate(-75.446 20.232) rotate(-8.474)",
    fill: "#e9c050"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.568,
    y: 511.972,
    width: 25.258,
    height: 25.258,
    rx: 4.963,
    transform: "translate(-76.617 15.04) rotate(-8.474)",
    fill: "#696969"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M952.349,417c-11.04,15.852-29.54,30.734-55.76,44.646C839.9,491.783,747.173,517.519,616.48,539.6c-10.742,1.828-21.483,3.543-32.076,5.222v-49.01c117-18.947,230.539-45.242,290.515-77.132,17.567-9.325,30.51-19.134,37.633-29.354,5.371-7.758,4.886-13.017,3.693-17.119-7.348-25.662-54.232-28.757-98.02-24.543a336.239,336.239,0,0,0-52.664-40.99c49.606-10.369,174.406-27.9,197.306,52.18C968.574,378.807,964.956,398.911,952.349,417Z",
    fill: "#e9c050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.4,495.811v49.01c-123.941,19.32-233.6,27.936-234.791,28.048l-3.73-48.338C414.81,519.2,500.483,509.388,584.4,495.811Z",
    fill: "#e9c050"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M306.922,510.344s-14.331-22.077,38.357-30.935c21.456-3.607,44.224,6.434,57.569,10.564,10.227,3.166,38.919,6.084,51.764,7.275a8.959,8.959,0,0,1,7.91,7.092,145.536,145.536,0,0,1-2.408,70,9.147,9.147,0,0,1-11.3,6.334c-18.776-5.646-37.571,1.249-37.571,1.249A390.944,390.944,0,0,1,320.112,598.4c-9.389.5-10.371-16.155-10.371-16.155Z",
    fill: "#fff",
    stroke: "#1a1a18",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.653,499.1,237.61,529.018c-17.407,4.69-18.079,20.971,10.114,17.233,24.362-3.23,64.532-8.448,64.532-8.448",
    fill: "#fff",
    stroke: "#1a1a18",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.548,559.1s-30.521,5.521-35.2,1.309-6.433-17.9-2.393-19.635,24.218-3.306,24.218-3.306",
    fill: "#fff",
    stroke: "#1a1a18",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.42,579.713S310.307,583,304.94,582.2s-9.555-16.46-5.318-20.147a140,140,0,0,0,18.963-1.288c9.3-1.377,10.963-1.663,10.963-1.663s-30.521,5.521-35.2,1.309-6.433-17.9-2.393-19.635,24.218-3.306,24.218-3.306",
    fill: "#fff",
    stroke: "#1a1a18",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 7.46
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFeatureToucan);
export default __webpack_public_path__ + "static/media/NewFeatureToucan.78ede9a10301fa08df59ef309f08e444.svg";
export { ForwardRef as ReactComponent };